// extracted by mini-css-extract-plugin
module.exports = {"root":"accept-cookies_root__j5dFC","content":"accept-cookies_content__3qixs"};